import prop from 'ramda/src/prop'

import apiRequest from 'root/src/client/logic/api/thunks/apiRequest'
import { ADD_COUPON, UPDATE_COUPON } from 'root/src/shared/descriptions/endpoints/endpointIds'
import addCouponOnSuccess from 'root/src/client/logic/coupon/actions/addCouponOnSuccess'
import updateCouponOnSuccess from 'root/src/client/logic/coupon/actions/updateCouponOnSuccess'
import clearAllForms from 'root/src/client/logic/form/actions/clearAllForms'
import setLoadingBlockList from 'root/src/client/logic/list/actions/setLoadingBlockList'
import { COUPON_LIST_ADMIN_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'

// eslint-disable-next-line no-unused-vars
export default formData => async (dispatch, getState) => {
	const couponId = prop('id', formData)
	dispatch(setLoadingBlockList(true, COUPON_LIST_ADMIN_MODULE_ID))

	if (couponId) {
		const response = await dispatch(apiRequest(UPDATE_COUPON, formData))
		dispatch(clearAllForms())
		dispatch(setLoadingBlockList(false, COUPON_LIST_ADMIN_MODULE_ID))
		return dispatch(updateCouponOnSuccess(response))
	}
	const response = await dispatch(apiRequest(ADD_COUPON, formData))
	dispatch(clearAllForms())
	dispatch(setLoadingBlockList(false, COUPON_LIST_ADMIN_MODULE_ID))
	return dispatch(addCouponOnSuccess(response))
}
